// src/components/PrivacyPolicyContent.js (CÓDIGO COMPLETO)
import React from 'react';

const PrivacyPolicyContent = () => {
    return (
        <div style={{ maxWidth: '900px', margin: '50px auto', padding: '0 20px', color: '#333' }}>
            <h1 style={{ color: 'var(--color-dorado, #e6b800)', borderBottom: '2px solid #ccc', paddingBottom: '10px' }}>
                Política de Privacidad y Confidencialidad
            </h1>
            <p style={{ fontStyle: 'italic', color: '#555' }}>
                Última actualización: Noviembre de {new Date().getFullYear()}.
            </p>
            <p style={{ marginTop: '20px' }}>
                Esta política rige la forma en que **Giovanni Scarvaci & Asociados** (en adelante, la "Firma") recopila, utiliza, mantiene y divulga la información obtenida de los usuarios de este sitio web.
            </p>

            <h3 style={{ marginTop: '30px', color: 'var(--color-negro, #000033)' }}>1. Compromiso con la Confidencialidad Profesional</h3>
            <p>
                Giovanni Scarvaci & Asociados se rige por la ética y el secreto profesional del abogado venezolano. La información legal, económica y patrimonial de nuestros clientes es de naturaleza sensible. 
                Nuestra prioridad es la **confidencialidad absoluta** de todos los datos e información compartidos durante el proceso de consulta y asesoría, conforme al Código de Ética Profesional del Abogado y las leyes de la República Bolivariana de Venezuela.
            </p>

            <h3 style={{ marginTop: '30px', color: 'var(--color-negro, #000033)' }}>2. Información Recopilada y Fines</h3>
            <p>
                Recopilamos información que usted nos proporciona voluntariamente, como:
            </p>
            <ul>
                <li>**Datos de Contacto:** Nombre, correo electrónico, número de teléfono (para comunicación).</li>
                <li>**Datos de Consulta:** Detalles de su caso legal o situación económica/patrimonial (para la prestación de servicios).</li>
            </ul>
            <p>
                Esta información se utiliza **exclusivamente** para:
            </p>
            <ul>
                <li>Proporcionar y gestionar los servicios de asesoría legal y financiera solicitados.</li>
                <li>Facturación y cumplimiento de obligaciones contractuales.</li>
                <li>Respuesta a sus consultas y peticiones.</li>
            </ul>

            <h3 style={{ marginTop: '30px', color: 'var(--color-negro, #000033)' }}>3. Protección y Jurisdicción de Datos</h3>
            <p>
                La Firma se compromete a no vender, alquilar o ceder su información personal a terceros. La divulgación de datos solo ocurrirá bajo las siguientes excepciones:
            </p>
            <ul>
                <li>Cuando usted otorgue su **consentimiento expreso y escrito**.</li>
                <li>Para el cumplimiento de un deber legal, mandato constitucional o una orden judicial emitida por autoridad competente en Venezuela.</li>
                <li>A otros profesionales de la Firma o peritos asociados que estrictamente necesiten la información para prestar el servicio profesional contratado.</li>
            </ul>
            <p>
                <strong>Marco Legal:</strong> El tratamiento de sus datos personales se rige por la legislación venezolana, incluyendo los principios de lealtad, probidad y ética inherentes al ejercicio de la abogacía en el territorio nacional.
            </p>

            <h3 style={{ marginTop: '30px', color: 'var(--color-negro, #000033)' }}>4. Derechos del Usuario (Titular de los Datos)</h3>
            <p>
                Como usuario, usted tiene el derecho de contactarnos para solicitar información sobre sus datos, su corrección, actualización o, en su caso, su eliminación, siempre y cuando estas acciones no contravengan nuestras obligaciones legales o éticas de preservación de archivos y documentos del cliente.
            </p>

            <h3 style={{ marginTop: '30px', color: 'var(--color-negro, #000033)' }}>5. Contacto</h3>
            <p>
                Si tiene preguntas sobre esta política o requiere ejercer sus derechos, por favor contáctenos a través de:
            </p>
            <p>Email: giovanniscarvaciyasociados@gmail.com</p>
            <p>Teléfono: +1 (407)873-8172</p>
            <p>Dirección: Sede Principal, Maracay-Estado Aragua, Venezuela.</p>
            <hr/>
            <p style={{ fontSize: '0.8em', textAlign: 'center', marginTop: '30px' }}>
                © {new Date().getFullYear()} Giovanni Scarvaci & Asociados. Todos los derechos reservados.
            </p>
        </div>
    );
};

export default PrivacyPolicyContent;